import { useState } from 'react';
import { auth, db } from '../lib/firebase';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';

const BG_COLORS  = ['#7c3aed','#2563eb','#059669','#d97706','#dc2626','#0891b2','#be185d'];
const TEXT_COLORS = ['#ddd6fe','#bfdbfe','#a7f3d0','#fde68a','#fecaca','#a5f3fc','#fbcfe8'];

function getInitials(name) {
  return name.trim().split(' ').map(w => w[0]).join('').toUpperCase().slice(0,2);
}

export default function AuthScreen() {
  const [mode, setMode]     = useState('signin'); // 'signin' | 'signup'
  const [name, setName]     = useState('');
  const [email, setEmail]   = useState('');
  const [pass, setPass]     = useState('');
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit() {
    setError(''); setLoading(true);
    try {
      if (mode === 'signup') {
        if (!name.trim()) { setError('Enter your name'); setLoading(false); return; }
        const cred = await createUserWithEmailAndPassword(auth, email, pass);
        const idx  = Math.floor(Math.random() * BG_COLORS.length);
        await setDoc(doc(db, 'users', cred.user.uid), {
          uid:          cred.user.uid,
          displayName:  name.trim(),
          initials:     getInitials(name),
          avatarBg:     BG_COLORS[idx],
          avatarText:   TEXT_COLORS[idx],
          online:       true,
          lastSeen:     serverTimestamp(),
        });
      } else {
        const cred = await signInWithEmailAndPassword(auth, email, pass);
        const snap = await getDoc(doc(db, 'users', cred.user.uid));
        if (snap.exists()) {
          await setDoc(doc(db, 'users', cred.user.uid), { online: true, lastSeen: serverTimestamp() }, { merge: true });
        }
      }
    } catch (e) {
      setError(e.message.replace('Firebase: ','').replace(/\(.*\)/,'').trim());
    }
    setLoading(false);
  }

  return (
    <div className="signin-screen">
      <div className="signin-logo">🏠</div>
      <div className="signin-title">hangout</div>
      <div className="signin-sub">your crew, your space</div>

      {mode === 'signup' && (
        <input
          className="modal-input"
          placeholder="your name"
          value={name}
          onChange={e => setName(e.target.value)}
          style={{ width: '100%', maxWidth: 320 }}
        />
      )}
      <input
        className="modal-input"
        placeholder="email"
        type="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        style={{ width: '100%', maxWidth: 320 }}
      />
      <input
        className="modal-input"
        placeholder="password"
        type="password"
        value={pass}
        onChange={e => setPass(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && handleSubmit()}
        style={{ width: '100%', maxWidth: 320 }}
      />
      {error && <div style={{ color: 'var(--danger)', fontSize: 13, marginBottom: 10 }}>{error}</div>}
      <button className="btn-primary" style={{ maxWidth: 320 }} onClick={handleSubmit} disabled={loading}>
        {loading ? '...' : mode === 'signin' ? 'sign in' : 'create account'}
      </button>
      <button
        onClick={() => { setMode(mode === 'signin' ? 'signup' : 'signin'); setError(''); }}
        style={{ marginTop: 16, color: 'var(--amber)', fontSize: 14 }}
      >
        {mode === 'signin' ? "don't have an account? sign up" : 'already have an account? sign in'}
      </button>
    </div>
  );
}
